export enum SharedEventNameEnum {
    login = 'login',
    refresh_token_expired = 'refresh_token_expired',
    logout = 'logout',
    after_logout = 'after_logout',
    goto_login_page = 'goto_login_page',
    app_init_successful = 'app_init_successful',

    // Fired after a brand-new HubConnection object is started (first connect, or a
    // manual rebuild after onclose). Hubs must (re)register their message handlers
    // AND re-join their server groups.
    signalr_reconnected = 'signalr_reconnected',
    // Fired after the SignalR client's own automatic reconnect succeeds. The
    // HubConnection object is the same (message handlers are still attached) but the
    // server connection id changed, so hubs must only re-join their server groups.
    signalr_resubscribe = 'signalr_resubscribe',
    // Fired when the connection has just recovered from an outage. Views / stores
    // should refetch, because updates emitted while the socket was down are lost.
    signalr_resync = 'signalr_resync',
    // Fired when the client has lost the connection and its automatic reconnect loop
    // has started. Useful for a "reconnecting..." indicator.
    signalr_connection_lost = 'signalr_connection_lost',
    route_change_success = 'route_change_success',

    call_subscribe = 'call_subscribe',
    call_unsubscribe = 'call_unsubscribe',
    call_new = 'call_new',

    capacity_subscribe = 'capacity_subscribe',
    capacity_unsubscribe = 'capacity_unsubscribe',
    capacity_organization_update = 'capacity_organization_update',
    capacity_job_role_update = 'capacity_job_role_update',
    capacity_user_update = 'capacity_user_update',

    chat_subscribe = 'chat_subscribe',
    chat_unsubscribe = 'chat_unsubscribe',
    chat_channel_new = 'chat_channel_new',
    chat_channel_name_update = 'chat_channel_name_update',
    chat_channel_access_update = 'chat_channel_access_update',
    chat_channel_delete = 'chat_channel_delete',

    chat_channel_collaborators_upsert = 'chat_channel_collaborators_upsert',
    chat_channel_collaborators_remove = 'chat_channel_collaborators_remove',

    chat_channel_message_upsert = 'chat_channel_message_upsert',
    chat_channel_message_reaction = 'chat_channel_message_reaction',
    chat_channel_message_delete = 'chat_channel_message_delete',

    chat_popver_show = 'chat_popver_show',

    contact_view_subscribe = 'contact_view_subscribe',
    contact_view_unsubscribe = 'contact_view_unsubscribe',
    contact_view_upsert = 'contact_view_upsert',
    contact_view_order_update = 'contact_view_order_update',
    contact_view_name_update = 'contact_view_name_update',
    contact_view_delete = 'contact_view_delete',
    contact_view_column_upsert = 'contact_view_column_upsert',
    contact_view_column_delete = 'contact_view_column_delete',

    // Custom Field
    custom_field_subscribe = 'custom_field_subscribe',
    custom_field_unsubscribe = 'custom_field_unsubscribe',
    custom_field_create = 'custom_field_create',
    custom_field_update = 'custom_field_update',
    custom_field_type_update = 'custom_field_type_update',
    custom_field_delete = 'custom_field_delete',
    custom_field_project_create = 'custom_field_project_create',
    custom_field_project_delete = 'custom_field_project_delete',

    // Discussion
    discussion_subscribe = 'discussion_subscribe',
    discussion_unsubscribe = 'discussion_unsubscribe',
    discussion_new = 'discussion_new',
    discussion_update = 'discussion_update',
    discussion_reactions_update = 'discussion_reactions_update',
    discussion_followers_update = 'discussion_followers_update',
    discussion_delete = 'discussion_delete',

    discussion_comment_new = 'discussion_comment_new',
    discussion_comment_update = 'discussion_comment_update',
    discussion_comment_reactions_update = 'discussion_comment_reactions_update',
    discussion_comment_delete = 'discussion_comment_delete',

    form_subscribe = 'form_subscribe',
    form_unsubscribe = 'form_unsubscribe',
    form_update = 'form_update',
    form_delete = 'form_delete',
    form_element_add = 'form_element_add',
    form_element_update = 'form_element_update',
    form_element_order_update = 'form_element_order_update',
    form_element_delete = 'form_element_delete',

    //Group
    group_subscribe = 'group_subscribe',
    group_unsubscribe = 'group_unsubscribe',
    group_create = 'group_create',
    group_base_update = 'group_base_update',
    group_order_update = 'group_order_update',
    group_delete = 'group_delete',

    //Membership
    membership_subscribe = 'membership_subscribe',
    membership_unsubscribe = 'membership_unsubscribe',
    membership_access_update = 'membership_access_update',
    membership_add = 'membership_add',
    membership_update_role = 'membership_update_role',
    membership_remove = 'membership_remove',

    // Organization
    organization_subscribe = 'organization_subscribe',
    organization_unsubscribe = 'organization_unsubscribe',
    organization_users_refresh = 'organization_users_refresh',
    organization_users_new = 'organization_users_new',
    organization_user_delete = 'organization_user_delete',
    organization_user_role_update = 'organization_user_role_update',
    organization_user_name_update = 'organization_user_name_update',
    organization_user_avatar_update = 'organization_user_avatar_update',
    organization_user_job_details_update = 'organization_user_job_details_update',
    organization_user_about_me_update = 'organization_user_about_me_update',
    organization_user_manager_update = 'organization_user_manager_update',
    organization_user_status_update = 'organization_user_status_update',
    organization_user_karma_points_update = 'organization_user_karma_points_update',
    organization_user_ping = 'organization_user_ping',
    organization_holiday_upsert = 'organization_holiday_upsert',
    organization_holiday_delete = 'organization_holiday_delete',
    organization_force_refresh = 'organization_force_refresh',

    organization_user_subscribe = 'organization_user_subscribe',
    organization_user_unsubscribe = 'organization_user_unsubscribe',
    organization_user_notification_new = 'organization_user_notification_new',
    organization_user_notification_all_archive_state = 'organization_user_notification_all_archive_state',
    organization_user_notifications_archive_state = 'organization_user_notifications_archive_state',
    organization_admin_changed = 'organization_admin_changed',

    out_of_office_subscribe = 'out_of_office_subscribe',
    out_of_office_unsubscribe = 'out_of_office_unsubscribe',
    out_of_office_upsert = 'out_of_office_upsert',
    out_of_office_delete = 'out_of_office_delete',

    //Portfolio
    portfolio_subscribe = 'portfolio_subscribe',
    portfolio_unsubscribe = 'portfolio_unsubscribe',
    portfolio_create = 'portfolio_create',
    portfolio_name_update = 'portfolio_name_update',
    portfolio_icon_color_update = 'portfolio_icon_color_update',
    portfolio_order_update = 'portfolio_order_update',
    portfolio_column_upsert = 'portfolio_column_upsert',
    portfolio_column_delete = 'portfolio_column_delete',
    portfolio_delete = 'portfolio_delete',

    portfolio_projects_add = 'portfolio_projects_add',
    portfolio_project_order_update = 'portfolio_project_order_update',
    portfolio_project_remove = 'portfolio_project_remove',

    // Project
    project_subscribe = 'project_subscribe',
    project_unsubscribe = 'project_unsubscribe',
    project_create = 'project_create',
    project_copied = 'project_copied',
    project_name_update = 'project_name_update',
    project_order_update = 'project_order_update',
    project_details_update = 'project_details_update',
    project_description_update = 'project_description_update',
    project_dates_update = 'project_dates_update',
    project_owner_update = 'project_owner_update',
    project_icon_color_update = 'project_icon_color_update',
    project_parent_update = 'project_parent_update',
    project_scheduling_update = 'project_scheduling_update',
    project_move_due_date_on_completion = 'project_move_due_date_on_completion',
    project_custom_field_value_update = 'project_custom_field_value_update',
    project_sprint_config_update = 'project_sprint_config_update',
    project_archive_update = 'project_archive_update',
    project_delete = 'project_delete',

    // Record
    record_subscribe = 'record_subscribe',
    record_unsubscribe = 'record_unsubscribe',
    record_new = 'record_new',
    record_update = 'record_update',
    record_update_multiple = 'record_update_multiple',
    record_delete = 'record_delete',
    record_activity_new = 'record_activity_new',
    record_activity_update = 'record_activity_update',
    record_activity_delete = 'record_activity_delete',
    record_estimate_update = 'record_estimate_update',
    record_billable_update = 'record_billable_update',
    record_timelog_billable_update = 'record_timelog_billable_update',
    record_timelog_upsert = 'record_timelog_upsert',
    record_jira_sync = 'record_jira_sync',

    //Report
    report_subscribe = 'report_subscribe',
    report_unsubscribe = 'report_unsubscribe',
    report_create = 'report_create',
    report_name_update = 'report_name_update',
    report_icon_color_update = 'report_icon_color_update',
    report_order_update = 'report_order_update',
    report_delete = 'report_delete',
    report_card_add = 'report_card_add',
    report_card_update = 'report_card_update',
    report_card_remove = 'report_card_remove',

    //Workflow
    workflow_subscribe = 'workflow_subscribe',
    workflow_unsubscribe = 'workflow_unsubscribe',
    workflow_create = 'workflow_create',
    workflow_name_update = 'workflow_name_update',
    workflow_order_update = 'workflow_order_update',
    workflow_delete = 'workflow_delete',
    // Execution lifecycle - server -> client only, pushed from the webjob (no client relay method).
    workflow_execution_start = 'workflow_execution_start',
    workflow_execution_finish = 'workflow_execution_finish',

    // Workflow Node
    workflow_node_subscribe = 'workflow_node_subscribe',
    workflow_node_unsubscribe = 'workflow_node_unsubscribe',
    workflow_node_upsert = 'workflow_node_upsert',
    workflow_node_delete = 'workflow_node_delete',

    //View
    view_subscribe = 'view_subscribe',
    view_unsubscribe = 'view_unsubscribe',
    view_create = 'view_create',
    view_update = 'view_update',
    view_name_update = 'view_name_update',
    view_order_update = 'view_order_update',
    view_access_update = 'view_access_update',
    view_delete = 'view_delete',
    view_column_upsert = 'view_column_upsert',
    view_column_delete = 'view_column_delete',
}
